/**
 * @graphql cc
 */
import gql from 'graphql-tag';

export const InlineCommentQuery = gql`
	query InlineCommentQuery(
		$annotationId: String
		$pageId: ID!
		$contentStatus: [GraphQLContentStatus]
	) {
		comments(inlineMarkerRef: $annotationId, pageId: $pageId, contentStatus: $contentStatus) {
			nodes {
				replies {
					id
					parentId
					body(representation: ATLAS_DOC_FORMAT) {
						value
					}
					createdAt {
						value
					}
					createdAtNonLocalized
					links {
						webui
						editui
					}
					author {
						displayName
						permissionType
						profilePicture {
							path
						}
						... on KnownUser {
							accountId
						}
					}
					location {
						type
					}
					version {
						by {
							displayName
						}
						when
						number
					}
					permissions {
						isEditable
						isRemovable
						isResolvable
					}
					reactionsSummary(pageId: $pageId, contentType: "page", childType: "comment") {
						reactionsCount
						ari
						containerAri
						reactionsSummaryForEmoji {
							emojiId
							count
							reacted
							id
						}
					}
				}
				version {
					by {
						displayName
					}
					when
					number
				}
				location {
					type
					... on InlineComment {
						inlineMarkerRef
						inlineText
						inlineResolveProperties {
							resolved
							resolvedTime
							resolvedUser
						}
					}
				}
				id
				body(representation: ATLAS_DOC_FORMAT) {
					value
				}
				createdAt {
					value
				}
				createdAtNonLocalized
				links {
					webui
					editui
				}
				author {
					displayName
					profilePicture {
						path
					}
					permissionType
					... on KnownUser {
						accountId
					}
				}
				permissions {
					isEditable
					isRemovable
					isResolvable
				}
				reactionsSummary(pageId: $pageId, contentType: "page", childType: "comment") {
					reactionsCount
					ari
					containerAri
					reactionsSummaryForEmoji {
						emojiId
						count
						reacted
						id
					}
				}
			}
		}
	}
`;
